// Pure, unit-testable helpers for the Add Lead "View Website" shortcut.
import { normalizeUrl } from '../../../../../../../utils/urlMetadata';

// Valid full website: optional scheme, domain + TLD, optional port/path/query/fragment, no spaces.
export const WEBSITE_PATTERN = /^(https?:\/\/)?([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(:\d+)?([/?#]\S*)?$/i;

/** True only for a well-formed full website (e.g. "example.com", "sub.example.co.in"). */
export const isValidWebsite = (value: string): boolean => WEBSITE_PATTERN.test((value || '').trim());

/** Normalizes a website value into an openable URL, prepending https:// when scheme-less. */
export const buildWebsiteUrl = (value: string): string => normalizeUrl(value);
